<template>
  <v-navigation-drawer
    v-model="drawer"
    :permanent="drawer"
    mini-variant expand-on-hover
    app
  >
    <v-toolbar dense>
      <v-app-bar-nav-icon @click.stop="_drawer = !_drawer"></v-app-bar-nav-icon>
    </v-toolbar>

    <v-list>

      <!-- -->

      <v-list-item :to="'/search'">
        <v-list-item-action>
          <v-icon color="success" light>search</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Search</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-tooltip right open-delay="600ms">
        <template #activator="{ on }">
          <v-list-item v-on="on" :to="'/sample_list'">
            <v-list-item-action>
              <v-icon>mdi-test-tube</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Samples</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template #default>
          <div>
            <dt>Samples (projects' collections)</dt>
            <dd>
            </dd>
          </div>
        </template>
      </v-tooltip>

      <v-list-item :to="'/plate_list'">
        <v-list-item-action>
          <!--          <v-icon>mdi-chart-bell-curve-cumulative</v-icon>-->
          <v-icon>mdi-table-multiple</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Plates</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <!-- ProbePlexes -->
      <v-tooltip right open-delay="600ms">

        <template #activator="{ on }">
          <v-list-item v-on="on" :to="'/probePlex_list'">
            <v-list-item-action>
              <v-icon>mdi-palette-advanced</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title>Probe plexes</v-list-item-title>
            </v-list-item-content>

          </v-list-item>
        </template>

        <div>
          <dt>Multiplexes of probes</dt>
          <dd>
            Probe multiplexes can be used for deconvolution <br/>
            of well spectral data to probe dye intensity
          </dd>
        </div>

      </v-tooltip>

      <v-tooltip right open-delay="600ms">
        <template #activator="{ on }">
          <v-list-item v-on="on" :to="'/seq_list'">
            <v-list-item-action>
              <!--              <v-icon>mdi-waves</v-icon>-->
              <seq-tcga-icon></seq-tcga-icon>
              <!--              <icon-base name="seq-tcga"></icon-base>-->
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Seqs</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <div>
          <dt>Sequences by Sanger method</dt>
          <dd>
            Electrophoresis data of <br/>
            polymerase reaction products with ddNTP (labeling).
          </dd>
        </div>
      </v-tooltip>

      <v-list-item :to="'/settings'" disabled>
        <v-list-item-action>
          <v-icon>tune</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>Настроки</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


      <v-list-item :to="'/about'">
        <v-list-item-action>
          <v-icon light>mdi-information-outline</v-icon>
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>О программе</v-list-item-title>
        </v-list-item-content>
      </v-list-item>


    </v-list>


  </v-navigation-drawer>

</template>

<script>

	import format from 'string-format'
	import {
		VNavigationDrawer, VToolbar, VAppBarNavIcon,
		VList, VListItem, VListItemAction, VListItemContent, VListItemTitle,
		VIcon
	} from 'vuetify'
	// import IconBase from "../IconBase"
	import SeqTcgaIcon from "../icons/SeqTcgaIcon"

	import {
		mdiTestTube, // sample_list
		mdiBottleTonicPlus, mdiHospitalBoxOutline,
		mdiChartBellCurveCumulative,
		mdiInformationOutline
	} from '@mdi/js'

	export default {
		name: "main-navigation-drawer",
		components: {
			VNavigationDrawer, VToolbar, VAppBarNavIcon,
			VList, VListItem, VListItemAction, VListItemContent, VListItemTitle,
			VIcon,
			// 'icon-base': IconBase,
			'seq-tcga-icon': SeqTcgaIcon,
		},
		data: function () {
			return {
				// drawer: false,
			}
		},
		props: {
			drawer: {
				type: Boolean,
				default: false
			},
		},
		computed: {
			_drawer: {
				get: function () {
					return this.drawer
				},
				set: function (value) {
					// console.debug(format("MainNavigationDrawerComponent.set_drawer({0})", value))
					this.$emit('drawer_change', value)
				}
			}
		}
	}
</script>

<style scoped>

</style>